import bulletIcon from '../../images/pristyn-care/bulletIcon.svg';
import React from 'react';

const Benefits = (props) => {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginTop: '16px',
          maxWidth: '306px',
        }}
      >
        <img
          src={bulletIcon}
          alt="bulletIcon"
          style={{ width: '8px', height: '8px', marginRight: '8px' }}
        />
        <p
          style={{
            color: '#465C67',
            fontFamily: 'var(--font-secondary)',
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: '15px',
          }}
        >
          {props.text}
        </p>
      </div>
    </div>
  );
};

export default Benefits;
